import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { useEventLogging } from '../../../../../../models/Logging';
import { useErrorMessagesContext } from '../../../../../components/ErrorModalProvider/context';
import { CustomSurveyResponse } from '../../components/CustomSurvey';
import { ICustomSurvey, IOperationResultNoValue } from '../../../../../models/Api';
import { useSurvey } from '../../../../../models/hooks';
import { Survey } from '../../../shared/Survey';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const CustomSurvey: React.FC<IProps> = props => {
	const { className, styles = [] } = props;
	const { params: urlParams = {}, path: matchPath } = useRouteMatch<{
		token?: string;
	}>();
	const h = useHistory();
	const { logApiError } = useEventLogging('CustomSurvey');
	const { pushError } = useErrorMessagesContext();

	const { hasAccessToken, isUnavailable, surveyQuery } = useSurvey<ICustomSurvey>({
		accessToken: urlParams.token,
		options: {
			expand: 'options',
		},
	});

	React.useEffect(() => {
		if (!hasAccessToken) {
			return;
		}

		if (surveyQuery.error) {
			logApiError('Survey-Error', surveyQuery.error as IOperationResultNoValue);
			pushError(surveyQuery.error);
			return;
		}

		if (surveyQuery.data && isUnavailable) {
			h.push(`${matchPath.toLocaleLowerCase().replace(':token?', 'unavailable')}`);
		}
	}, [h, hasAccessToken, isUnavailable, logApiError, matchPath, pushError, surveyQuery.data, surveyQuery.error]);

	return (
		<Survey
			cardStyles={[styleSheet.surveyContent]}
			className={`custom-survey-container ${className || ''}`}
			styles={[styleSheet.container, ...styles]}
			survey={surveyQuery.data}
		>
			<Switch>
				<Route path={`${matchPath.toLocaleLowerCase().replace(':token?', 'unavailable')}`}>
					<div className={css(styleSheet.unavailable)}>
						<p>This survey is not available at this time.</p>
					</div>
				</Route>
				<Route>{surveyQuery.data && <CustomSurveyResponse survey={surveyQuery.data} />}</Route>
			</Switch>
		</Survey>
	);
};
